// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import {
  InfiniteScroll, Option, Pagination, DatePicker, Select,
  TableColumn, Table, TabPane, Radio, Input,
  Button, Tabs, Loading, Upload, RadioGroup, Slider, Carousel,
  CarouselItem, Progress, Dialog, Form, FormItem, Badge, Message, Image,
  Container, Header, Aside, Main, Switch
}
  from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
// 引入懒加载
import VueLazyload from 'vue-lazyload'

import { publickCdn, privateCdn, projectType, enname, bbh, name, httpwz } from '@/config/index'
// 公共的图片cdn
Vue.prototype.$publickCdn = publickCdn
// 私有的图片cdn
Vue.prototype.$privateCdn = privateCdn
// 项目类型
Vue.prototype.$projectType = projectType
// 项目对应的英文名
Vue.prototype.$enname = enname
// 项目对应的版本号
Vue.prototype.$bbh = bbh
// 项目对应的中文名
Vue.prototype.$name = name
Vue.prototype.$theme = projectType
Vue.prototype.$httpwz = httpwz

// 全局注册组件
import './utils/globalVue'
import './assets/common/reset.css'
import './assets/common/common.css'
import Directive from './view/directives/loadingshow'
import '@/utils/util.js'
Vue.directive('loadingshow', Directive)
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Button);
Vue.use(Container);
Vue.use(Input)
Vue.use(Radio)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(DatePicker)
Vue.use(Pagination)
Vue.use(Option)
Vue.use(Upload)
Vue.use(RadioGroup)
Vue.use(Slider)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(InfiniteScroll)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(Badge)
Vue.use(FormItem);
Vue.use(Switch);
Vue.use(VueLazyload)
Vue.prototype.$lazy = {
  error_avatar: `${publickCdn}static/broadcast/img/moren_people2.png`,
  error_logo: `${publickCdn}static/broadcast/img/preload_logo.png`,
  error_people: `${publickCdn}static/broadcast/img/people_mrs.png`,
}
import router from './router'
import store from './store'
import ElementLocale from 'element-ui/lib/locale'
import i18n from './i18n'

// 安装 Element UI 多语言插件
Vue.use(ElementLocale, { i18n: (key, value) => i18n.t(key, value) })

// 安装 VueMeta
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  async: true
})

// 为了实现Class的私有属性
const showMessage = Symbol('showMessage')
class DonMessage {
  success(options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single = true) {
    this[showMessage]('info', options, single)
  }
  error(options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
Vue.prototype.$message = new DonMessage()
// 所有的axios请求
import api from '../src/request/api/index'
// socket连接
import webscokets from '../src/request/socket/socketGloab'
// Vue.prototype.$webscokets = webscokets
Vue.config.productionTip = false
Vue.prototype.$api = api
/* eslint-disable no-new */
if (window.localStorage.getItem('fingerprintVal')) {
  window.publicws = new webscokets('all')
  window.publicws.Init()
} else if (typeof FingerprintJS !== 'undefined') {
  FingerprintJS.load().then(fp => {
    fp.get().then(result => {
      window.localStorage.setItem('fingerprintVal', result.visitorId)
      window.publicws = new webscokets('all')
      window.publicws.Init()
    });
  });
} else {
  // FingerprintJS 未加载，使用默认值
  window.localStorage.setItem('fingerprintVal', 'web-' + Date.now())
  window.publicws = new webscokets('all')
  window.publicws.Init()
}
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
